import React from 'react';

function useDynamicStyle(cssString: string): void {
  React.useEffect(() => {
    const existingStyleElement = document.querySelector(`style[data-id="vendex-styles"]`);

    if (existingStyleElement) {
      existingStyleElement.textContent = cssString;
    } else {
      const styleElement = document.createElement('style');
      styleElement.dataset.id = 'vendex-styles';
      styleElement.textContent = cssString;
      document.head.appendChild(styleElement);
    }

    return () => {
      const styleElement = document.querySelector(`style[data-id="vendex-styles"]`);
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, [cssString]);
}

export default useDynamicStyle;
